document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      
      const items = document.querySelectorAll('.nav-container .has-children');
      
      if(items) {
  
        items.forEach(li => {
            const href = li.querySelector('a').href;
            const link = li.querySelector('span:nth-child(1)');
    
            link.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                event.preventDefault();
                window.location.href = href;
            });
        });
      }
    }, 1000);
});

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
    var templateCollection = document.querySelector('.template-collection');
    if (templateCollection) {
        var siteControl = templateCollection.querySelector('#site-control');
        
        if (siteControl) {
            // Clone the siteControl element to remove all event listeners
            var newSiteControl = siteControl.cloneNode(true);
            siteControl.parentNode.replaceChild(newSiteControl, siteControl);
            siteControl = newSiteControl;

            var timeout;

            function addNavOpaque() {
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    siteControl.classList.add('nav-opaque');
                }, 20);
            }

            // Initial call
            addNavOpaque();

            // Check on scroll
            window.addEventListener('scroll', addNavOpaque);

            // Prevent other scripts from adding event listeners to siteControl
            var originalAddEventListener = siteControl.addEventListener;
            siteControl.addEventListener = function(type, listener, options) {
                console.warn(`Blocked an attempt to add a ${type} event listener to #site-control`);
            };

            // Optionally, you can override addEventListener globally if necessary
            var originalGlobalAddEventListener = EventTarget.prototype.addEventListener;
            EventTarget.prototype.addEventListener = function(type, listener, options) {
                if (this === siteControl) {
                    console.warn(`Blocked an attempt to add a ${type} event listener to #site-control`);
                } else {
                    originalGlobalAddEventListener.call(this, type, listener, options);
                }
            };
        }
    }
    }, 500);
});

(function() {
  function updateFilterPosition() {
    const siteControl = document.getElementById('site-control');
    const filterRoot = document.getElementById('cloud_search_filters_root');
    
    if (siteControl && filterRoot) {
      const height = siteControl.offsetHeight;
      filterRoot.style.top = `${height}px`;
    }
  }

  function init() {
    // Initial update
    updateFilterPosition();

    // Create a ResizeObserver to monitor size changes
    const resizeObserver = new ResizeObserver(updateFilterPosition);

    // Start observing the site-control element
    const siteControl = document.getElementById('site-control');
    if (siteControl) {
      resizeObserver.observe(siteControl);
    }

    // Update on window resize
    window.addEventListener('resize', updateFilterPosition);

    // Update on scroll
    window.addEventListener('scroll', function() {
      requestAnimationFrame(updateFilterPosition);
    });

    // Watch for 'scrolled-up' class changes on body
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          setTimeout(updateFilterPosition, 100);
          requestAnimationFrame(updateFilterPosition);
        }
      });
    });

    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

const initializeMenu = () => {
  const topLevelItems = document.querySelectorAll('.pod-nav > ul > li');
  const closeMenuButton = document.querySelector('.menu[data-modal-nav-toggle]');
  
  // Transform text in all link spans to title case
  document.querySelectorAll('.pod-nav a span').forEach(span => {
    const text = span.textContent.toLowerCase();
    span.textContent = text.charAt(0).toUpperCase() + text.slice(1);
  });

  // Function to remove active class from all links
  const removeAllActive = () => {
    document.querySelectorAll('.pod-nav a').forEach(link => {
      link.classList.remove('link-active');
    });
  };

  // Function to get the level of an item (1, 2, or 3)
  const getItemLevel = (item) => {
    let level = 0;
    let currentElement = item;
    
    while (currentElement && !currentElement.classList.contains('pod-nav')) {
      if (currentElement.tagName === 'UL') {
        level++;
      }
      currentElement = currentElement.parentElement;
    }
    
    return level;
  };

  // Function to reset menu to initial state
  const resetMenuToInitialState = () => {
    removeAllActive();
    
    // Show all top-level menu items
    topLevelItems.forEach(item => {
      item.style.display = 'block';
      
      // Show the link itself
      const link = item.querySelector(':scope > a');
      if (link) {
        link.style.display = '';
      }
      
      // Hide all submenus at all levels
      item.querySelectorAll('ul').forEach(submenu => {
        submenu.style.display = 'none';
      });
      
      // Show all child links
      item.querySelectorAll('li > a').forEach(childLink => {
        childLink.style.display = '';
      });
    });

    // Reset all indicators
    document.querySelectorAll('.submenu-indicator').forEach(indicator => {
      indicator.classList.remove('has-back-arrow');
    });
  };
  
  // Recursive function to process all items with submenus
  const processItem = (item) => {
    const link = item.querySelector(':scope > a');
    const subMenu = item.querySelector(':scope > ul');
    const isMegaParent = item.hasAttribute('data-mega-parent');
    const level = getItemLevel(item);
    
    if (subMenu) {
      // Create indicator element
      const indicator = document.createElement('button');
      indicator.className = 'submenu-indicator';
      indicator.setAttribute('aria-label', 'Toggle submenu');
      indicator.type = 'button';
      
      // Insert indicator after the link text
      const linkText = link.querySelector('span');
      linkText.parentNode.insertBefore(indicator, linkText.nextSibling);
      
      // Remove aria-haspopup from link and add to indicator
      link.removeAttribute('aria-haspopup');
      indicator.setAttribute('aria-haspopup', 'true');
      
      const showSubmenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Remove active class from all links
        removeAllActive();
        
        // Always add link-active to current link (even for mega parents when showing their children)
        link.classList.add('link-active');
        
        indicator.classList.add('has-back-arrow');
        
        // Get parent UL and all siblings
        const parentUL = item.parentElement;
        const siblings = Array.from(parentUL.children);
        
        // Hide all siblings except current item
        siblings.forEach(sibling => {
          if (sibling !== item) {
            sibling.style.display = 'none';
          }
        });
        
        // Find the grandparent item (parent's parent) and hide its link
        const grandparentItem = parentUL.closest('li');
        if (grandparentItem) {
          const grandparentLink = grandparentItem.querySelector(':scope > a');
          if (grandparentLink) {
            grandparentLink.style.display = 'none';
          }
        }
        
        // Show submenu items
        const subMenuItems = subMenu.querySelectorAll(':scope > li');
        subMenuItems.forEach(subItem => {
          subItem.style.display = 'block';
        });
        subMenu.style.display = 'block';
        
        // Switch to back button mode
        indicator.removeEventListener('click', showSubmenu);
        indicator.addEventListener('click', handleBack);
      };

      const handleBack = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        indicator.classList.remove('has-back-arrow');
        
        // Remove active class
        removeAllActive();
        
        // Hide current submenu
        subMenu.style.display = 'none';
        
        // Get parent UL and show all siblings
        const parentUL = item.parentElement;
        const siblings = Array.from(parentUL.children);
        
        siblings.forEach(sibling => {
          sibling.style.display = 'block';
          
          // Show sibling links
          const siblingLink = sibling.querySelector(':scope > a');
          if (siblingLink) {
            siblingLink.style.display = '';
          }
          
          // Hide any open submenus in siblings
          const siblingSubmenu = sibling.querySelector(':scope > ul');
          if (siblingSubmenu) {
            siblingSubmenu.style.display = 'none';
          }
        });
        
        // Show the grandparent link again
        const grandparentItem = parentUL.closest('li');
        if (grandparentItem) {
          const grandparentLink = grandparentItem.querySelector(':scope > a');
          if (grandparentLink) {
            grandparentLink.style.display = '';
          }
        }
        
        // Reset indicator to original state
        indicator.removeEventListener('click', handleBack);
        indicator.addEventListener('click', showSubmenu);
      };
      
      // Initial event listener setup
      indicator.addEventListener('click', showSubmenu);
      link.addEventListener('click', showSubmenu);
      
      // Recursively process children with submenus
      const childItems = subMenu.querySelectorAll(':scope > li');
      childItems.forEach(childItem => {
        processItem(childItem);
      });
    } else {
      // For links without submenus, just handle active state
      link.addEventListener('click', (e) => {
        e.stopPropagation();
        removeAllActive();
        link.classList.add('link-active');
      });
    }
  };
  
  // Process all top-level items
  topLevelItems.forEach(item => {
    processItem(item);
  });

  // Add event listener to close menu button to reset menu state
  if (closeMenuButton) {
    closeMenuButton.addEventListener('click', (e) => {
      resetMenuToInitialState();
    });
  }

  // Also listen for when the menu modal is closed by other means
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-modal-nav-toggle]') || 
        e.target.closest('[data-modal-nav-toggle]')) {
      resetMenuToInitialState();
    }
  });
};

document.addEventListener('DOMContentLoaded', initializeMenu);

// Coupon Toggle Functionality
document.addEventListener('DOMContentLoaded', function() {
  const couponToggle = document.getElementById('coupon-toggle');
  const couponContainer = document.getElementById('coupon-container');

  // Only proceed if the main elements exist
  if (!couponToggle || !couponContainer) return;

  const toggleText = couponToggle.querySelector('span');

  // Only proceed if toggleText exists
  if (!toggleText) return;

  // Initially hide the coupon container
  couponContainer.style.display = 'none';

  // Add click event listener to the toggle
  couponToggle.addEventListener('click', function() {
    const isVisible = couponContainer.style.display !== 'none';

    if (isVisible) {
      couponContainer.style.display = 'none';
      toggleText.textContent = 'Got a discount code? Enter it here';
      couponToggle.classList.remove('active');
    } else {
      couponContainer.style.display = 'block';
      toggleText.textContent = 'Close discount code';
      couponToggle.classList.add('active');
    }

    // Update aria-expanded
    couponToggle.setAttribute('aria-expanded', (!isVisible).toString());
  });

  // Add hover effect and cursor pointer
  couponToggle.style.cursor = 'pointer';

  // Keyboard accessibility
  couponToggle.setAttribute('tabindex', '0');
  couponToggle.setAttribute('role', 'button');

  couponToggle.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      couponToggle.click();
    }
  });
});

document.addEventListener('click', function(e) {
  const trigger = e.target.closest('#llHeaderSearchTrigger');
  const cancelButton = e.target.closest('.cloud-search-mobile__cancel');
  
  if (!trigger && !cancelButton) return;

  const headerSearch = document.getElementById('llHeaderSearchForm');
  const headerSearchContainer = document.querySelector('.ll-header-search__container');
  const searchInput = document.getElementById('llHeaderSearchInput');
  const searchIcon = document.getElementById('llHeaderSearchIcon');
  const closeIcon = document.getElementById('llHeaderSearchCloseIcon');

  if (!headerSearch) return;

  const isActive = headerSearch.classList.contains('ll-header-search__form--active');

  // If cancel button is clicked, hide the entire search
  if (cancelButton) {
    headerSearch.style.display = 'none';
    headerSearch.classList.remove('ll-header-search__form--active');
    headerSearchContainer?.classList.remove('ll-header-search__container--active');
    searchIcon.style.display = 'block';
    closeIcon.style.display = 'none';
    document.getElementById('llHeaderSearchTrigger')?.setAttribute('aria-label', 'Open search');
    return;
  }

  // Show the search if it was hidden
  if (headerSearch.style.display === 'none') {
    headerSearch.style.display = '';
  }

  // Toggle behavior for the main trigger
  if (isActive) {
    // Close
    headerSearch.classList.remove('ll-header-search__form--active');
    headerSearchContainer?.classList.remove('ll-header-search__container--active');
    searchIcon.style.display = 'block';
    closeIcon.style.display = 'none';
    trigger.setAttribute('aria-label', 'Open search');
  } else {
    // Open
    headerSearch.classList.add('ll-header-search__form--active');
    headerSearchContainer?.classList.add('ll-header-search__container--active');
    searchIcon.style.display = 'none';
    closeIcon.style.display = 'block';
    trigger.setAttribute('aria-label', 'Close search');

    setTimeout(() => searchInput.focus(), 150);
  }
});

// Collections Swiper - Desktop Only
(function() {
  let swiperInstance = null;
  
  function initCollectionsSwiper() {
    const postcardsContainer = document.querySelector('.postcards[data-collection-count]');
    if (!postcardsContainer) return;
    
    const collectionCount = parseInt(postcardsContainer.dataset.collectionCount);
    if (collectionCount <= 7) return;
    
    const swiperEl = document.querySelector('#collections-swiper');
    if (!swiperEl) return;
    
    // Tablet & Desktop: Initialize Swiper (768px+)
    if (window.innerWidth >= 768) {
      if (!swiperInstance) {
        swiperInstance = new Swiper('#collections-swiper', {
          slidesPerView: 7, // Base default for 768px+
          spaceBetween: 20,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          navigation: {
            nextEl: '.js-swiper-button-next',
            prevEl: '.js-swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          direction: 'horizontal',
          watchOverflow: true,
          breakpoints: {
            // At 1024px and above, show 4 slides
            1024: {
              slidesPerView: 4,
              spaceBetween: 20
            }
          },
          on: {
            init: function() {
              this.update();
              this.slideTo(0, 0);
            }
          }
        });
      } else {
        swiperInstance.update();
      }
    } else {
      // Mobile: Destroy Swiper (below 768px)
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }
  
  // Initialise on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionsSwiper);
  } else {
    initCollectionsSwiper();
  }
  
  // Reinitialise on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initCollectionsSwiper, 250);
  });
})();

(function() {
  function init() {
    let lastScrollTop = 0;
    let ticking = false;

    function updateScrollDirection() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > lastScrollTop) {
        // Scrolling down
        document.body.classList.remove('scrolled-up');
      } else if (scrollTop < lastScrollTop) {
        // Scrolling up
        document.body.classList.add('scrolled-up');
      }
      
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDirection);
        ticking = true;
      }
    });
  }

  // Document ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Guides Swiper
(function() {
  let guidesSwiperInstance = null;

  function initGuidesSwiper() {
    const postcardsContainer = document.querySelector('.guides-section[data-collection-count]');
    if (!postcardsContainer) return;

    const collectionCount = parseInt(postcardsContainer.dataset.collectionCount);
    if (collectionCount <= 4) return;

    const swiperEl = document.querySelector('#guides-swiper');
    if (!swiperEl) return;

    if (!guidesSwiperInstance) {
      guidesSwiperInstance = new Swiper('#guides-swiper', {
        slidesPerView: 4,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
          nextEl: '.js-guides-next',
          prevEl: '.js-guides-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        direction: 'horizontal',
        watchOverflow: true,
        breakpoints: {
          // Mobile: show fewer slides
          0: {
            slidesPerView: 1.5,
            spaceBetween: 0
          },
          480: {
            slidesPerView: 1.5,
            spaceBetween: 0
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 0
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 0
          }
        },
        on: {
          init: function() {
            this.update();
            this.slideTo(0, 0);
          }
        }
      });
    } else {
      guidesSwiperInstance.update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuidesSwiper);
  } else {
    initGuidesSwiper();
  }

  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initGuidesSwiper, 250);
  });
})();

// Product Page Guides Swiper
(function() {
  let productGuidesSwiperInstance = null;
  let retryCount = 0;
  const maxRetries = 10;

  function initProductGuidesSwiper() {
    console.log('[ProductGuides] initProductGuidesSwiper called, attempt:', retryCount + 1);

    const swiperEl = document.querySelector('#product-guides-swiper');
    if (!swiperEl) {
      console.warn('[ProductGuides] #product-guides-swiper not found — aborting');
      return;
    }

    // If width is 0, element isn't visible/laid out yet — retry
    if (swiperEl.offsetWidth === 0) {
      retryCount++;
      if (retryCount <= maxRetries) {
        console.log('[ProductGuides] offsetWidth is 0, retrying in 300ms... (attempt ' + retryCount + ')');
        setTimeout(initProductGuidesSwiper, 300);
      } else {
        console.warn('[ProductGuides] max retries reached, giving up');
      }
      return;
    }

    console.log('[ProductGuides] swiperEl offsetWidth:', swiperEl.offsetWidth);
    retryCount = 0; // reset for future calls

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    console.log('[ProductGuides] wrapper computed display:', wrapper ? getComputedStyle(wrapper).display : 'n/a');
    console.log('[ProductGuides] wrapper offsetWidth:', wrapper ? wrapper.offsetWidth : 'n/a');

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    console.log('[ProductGuides] slide count:', slides.length);
    console.log('[ProductGuides] slide[0] offsetWidth:', slides[0] ? slides[0].offsetWidth : 'n/a');

    if (!productGuidesSwiperInstance) {
      console.log('[ProductGuides] creating new Swiper instance');
      productGuidesSwiperInstance = new Swiper('#product-guides-swiper', {
        slidesPerView: 2,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
          nextEl: '.js-product-guides-next',
          prevEl: '.js-product-guides-prev',
        },
        direction: 'horizontal',
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          480: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 20
          }
        },
        on: {
          init: function() {
            console.log('[ProductGuides] Swiper init fired');
            console.log('[ProductGuides] swiper width:', this.width);
            console.log('[ProductGuides] slidesPerView:', this.params.slidesPerView);
            console.log('[ProductGuides] spaceBetween:', this.params.spaceBetween);
            console.log('[ProductGuides] slidesSizesGrid:', this.slidesSizesGrid);
            this.update();
            this.slideTo(0, 0);
          },
          resize: function() {
            console.log('[ProductGuides] resize — width:', this.width, '| slidesPerView:', this.params.slidesPerView);
          }
        }
      });

      console.log('[ProductGuides] instance created:', productGuidesSwiperInstance);
    } else {
      console.log('[ProductGuides] instance already exists — updating');
      productGuidesSwiperInstance.update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGuidesSwiper);
  } else {
    initProductGuidesSwiper();
  }

  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initProductGuidesSwiper, 250);
  });
})();